import { QueryClient } from '@tanstack/react-query';
import { defaultRetryFunction } from './queryRetry';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: defaultRetryFunction,
      retryDelay: 3000,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
    mutations: {
      networkMode: 'always',
      retry: defaultRetryFunction,
    },
  },
});

export default queryClient;
